import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styles from "./backtolistbutton.module.scss";
import SonicLink from "../../common/routing/SonicLink";

type Props = {
  name: string;
  to: string;
  max_width?: number;
};
const BackToListButton: React.FC<Props> = ({ name, to, max_width }) => {
  return (
    <div
      className={styles["backtolist"]}
      style={max_width ? { maxWidth: `${max_width}px` } : {}}
    >
      <SonicLink to={to} className={styles["backtolist_link"]}>
        <span className={styles["backtolist_link_text"]}>
          <FontAwesomeIcon
            icon={["fas", "angle-left"]}
            className={styles["angle-left"]}
          />
          {`${name}一覧へ`}
        </span>
      </SonicLink>
    </div>
  );
};

export default BackToListButton;
